/**
 * Spin product prize: one line title (Variant + Size)
 */
export function getSpinProductDisplayLines(item) {
  const src = item || {};
  const fromApi = String(src.product_name || '').trim();
  if (fromApi) {
    return { displayName: fromApi };
  }

  const variantName = String(src.product_variant_name || '').trim();
  const sizeName = String(src.product_size_name || '').trim();
  const fallback = String(src.prize_label || 'Hadiah').trim() || 'Hadiah';

  const parts = [];
  if (variantName) parts.push(variantName);
  if (sizeName) parts.push(sizeName);

  return { displayName: parts.length > 0 ? parts.join(' ') : fallback };
}
